"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAddress = exports.updateAddressDataAction = exports.createAddressDataAction = void 0;
const typesafe_actions_1 = require("typesafe-actions");
const consts_1 = require("./consts");
// eslint-disable-next-line import/prefer-default-export
exports.createAddressDataAction = (0, typesafe_actions_1.createAction)(consts_1.CREATE_ADDRESS_DATA)();
exports.updateAddressDataAction = (0, typesafe_actions_1.createAction)(consts_1.UPDATE_ADDRESS_DATA)();
exports.deleteAddress = (0, typesafe_actions_1.createAction)(consts_1.DELETE_ADDRESS_DATA)();
